
import * as cnt from './constants';

export function updateSameAsCorporatePolicyNotes(templateDraftId, sectionValue, checked) {
  return {
    type: cnt.UPDATE_SAME_AS_CORPORATE_POLICY_NOTES,
    payload: {
      templateDraftId,
      sectionValue,
      checked,
    },
  };
}

export function removeMasterTemplate() {
  return {
    type: cnt.REMOVE_MASTER_TEMPLATE,
  };
}

export const sendReviewRatesEmail = payload => ({ type: cnt.REVIEW_MY_RATES_DRAFT, payload });

export const manageExtrasOffers = payload => ({ type: cnt.MANAGE_EXTRAS_OFFERS, payload });

export const removeSingleFeedByTCAdmin = ({ historyFeedId, messageId }) => ({
  type: cnt.REMOVE_SINGLE_FEED_BY_TC_ADMIN,
  payload: {
    historyFeedId,
    messageId,
  },
});

export const getNotes = payload => ({ type: cnt.GET_NOTES, payload });

export const fileContractForRequest = payload => ({ type: cnt.FILE_CONTRACT_FOR_REQUEST, payload });

export const removeContractFromRequest = payload => ({ type: cnt.REMOVE_CONTRACT_FROM_REQUEST, payload });



// WEBPACK FOOTER //
// ./src/app/components/contracting/__storeFiles__/actions.js